export default class Settings
{
	static keysWithDefaults = Object.freeze({
		"AUTH_TOKEN": null,
		"EXTENDED_SESSION_TIMEOUT": false,
		"LANGUAGE": "sv",
		"CASE_ID": null,
		"LAST_VIEW": null,
		"FA_SSN": null,
		"ACTIVE_ADVISOR": null
	});

  static exposedKeys = Object.freeze([
    "LANGUAGE",
    "EXTENDED_SESSION_TIMEOUT"
  ]);

	static get(key)
	{
		try
		{
			if (typeof Settings.keysWithDefaults[key] === "undefined")
			{
				throw new Error("UNKNOWN_KEY");
			}

			const value = localStorage.getItem(key);
      if (value === null) {
        return Settings.keysWithDefaults[key];
      }

      return Settings.exposedKeys.includes(key)
        ? JSON.parse(value)
        : JSON.parse(atob(value));
		} catch (e)
		{
			console.error({status: e, key});
		}
	}

	static set(key, value)
	{
		try
		{
			if (typeof Settings.keysWithDefaults[key] === "undefined")
			{
				throw new Error("UNKNOWN_KEY");
			}

      const json = JSON.stringify(value);
      localStorage.setItem(key, Settings.exposedKeys.includes(key) ? json : btoa(json));
		} catch (e)
		{
			console.error({status: e, key});
		}
	}

	static remove(key)
	{
		localStorage.removeItem(key);
	}

	static clear()
	{
		for (const key in Settings.keysWithDefaults)
		{
			if (key !== "EXTENDED_SESSION_TIMEOUT")
			{
				localStorage.removeItem(key);
			}
		}
	}
}